import api from '../services/api';
import { debounce } from '../utils/debounce';
import { $Q, $Qll } from '../utils/query-selector';
import { stringToHTML } from '../utils/to-html';
import { toggleDataActive } from '../utils/toggle-dataset';

/**
 * Init script Predictive search
 */
export const mountPredictiveSearch = () => {
  // ? event toggle icon search - show input search
  toggleDataActive('.search-js', '#search-predictive', {
    closeSelector: '.icon-close-js',
    overlay: false,
  });

  // ? event change input search
  const searchInputs = $Qll("input[type='search']");
  searchInputs.forEach((input) => {
    input.addEventListener(
      'input',
      debounce((event) => {
        onChangePredictive(event);
      }, 300).bind(this),
    );
  });
};

/**
 *
 * @param {Event} event - event input change in field search
 * if is text letter is open and execute query fetch api, else close suggest
 */
const onChangePredictive = (event) => {
  const searchTerm = event.target.value.trim();

  if (!searchTerm.length) {
    close(event.target);
    return;
  }
  open(event.target);
  elementListContainer(event.target).innerHTML = `
    <div class="loading-container">
      <div id='loading'></div>
    <div>`;
  setTimeout(() => {
    getSearchResults(searchTerm, event.target);
  }, 100);
};

/**
 * get list result for query api.
 * @param {String} searchTerm - query search
 */
const getSearchResults = async (searchTerm, parent) => {
  // ? params custom search (customize in snippet "predictive-search")
  const limitSearch =
    parent.closest('#search-predictive').dataset.configLimit || 5;
  const paramsSearch =
    parent.closest('#search-predictive').dataset.configParams || 'product';

  const base = `${routes.predictive_search_url}?q=${searchTerm}&resources[type]=${paramsSearch}&resources[limit]=${limitSearch}&resources[options][fields]=title,product_type,tag,variants.title,variants.sku,variants.barcode`;
  const result = await api.shopifySectionByUrl(
    base,
    'predictive-search',
    '&section_id',
  );
  const listItems = $Q('#predictive-search-results', stringToHTML(result));
  // ? add element result in container list predictive
  elementListContainer(parent).innerHTML = listItems.outerHTML;
};

const open = (parent) => {
  elementListContainer(parent).style.display = 'block';
};

const close = (parent) => {
  elementListContainer(parent).style.display = 'none';
};

const elementListContainer = (parent) => $Q('#predictive-search-list', parent.closest('form'));
